export var convertToTimestamp = date => {
  return date === null || date === void 0 ? void 0 : date.getTime();
};